import types from './types';
import HTTPError from '~/misc/HTTPError';

import {promiseAction, ActionError} from '~/misc/dispatch';
import * as api from './api';

export const getPaymentHistory = (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.GET_PAYMENT_HISTORY,
  Promise.all([
    api.getPaymentHistoryApi(getState).catch(error => {
      if (!(error instanceof HTTPError)) {
        throw error;
      }
      return error.response.json().then(body => {
        const errorMessage = body.state_message;
        throw new ActionError(errorMessage);
      });
    }),
    api.getAppPaymentHistoryApi(getState).catch(error => {
      if (!(error instanceof HTTPError)) {
        throw error;
      }
      return error.response.json().then(body => {
        const errorMessage = body.state_message;
        throw new ActionError(errorMessage);
      });
    })
  ])
  // .catch(err => {
  //   throw new ActionError();
  // })
);
export const getPaymentNextBillDate = (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.GET_PAYMENT_NEXT_BILL_DATE,
  Promise.all([
    api.getPaymentNextBillDateApi(getState).catch(error => {
      if (!(error instanceof HTTPError)) {
        throw error;
      }
      return error.response.json().then(body => {
        const errorMessage = body.state_message;
        throw new ActionError(errorMessage);
      });
    }),
    api.getAppPaymentHistoryApi(getState).catch(error => {
      if (!(error instanceof HTTPError)) {
        throw error;
      }
      return error.response.json().then(body => {
        const errorMessage = body.state_message;
        throw new ActionError(errorMessage);
      });
    })
  ])

);



// WEBPACK FOOTER //
// ./src/modules/paymentHistoryPage/actions.js